import { minutesDiff } from "../../utilities/funcs"

export const calcBlocks = (start:Date, end:Date) => {
    start.setSeconds(0,0)
    end.setSeconds(0,0)
    let minutes = minutesDiff(start, end)
    //console.log(minutes, start, end)
    return Math.floor(minutes/30) 
}